/**
 * @file
 * <pre>
 *
 * Bootstrap for the display app.
 *
 * Summary of responsibilities:
 *
 *  - provides a clear separation between new and legacy code paths!
 *
 *  - imports and inits legacy NGX scoped modules (there is still a LOT of core functionality
 *    here that has not yet been migrated to React/Redux architecture) :(
 *
 *  - imports and inits new NGXD scoped React/Redux apps.
 * </pre>
 *
 * @author Tim Loram
 * @see module:NGXD
 */

// Disable Reselect 5 development mode warnings globally
import { setGlobalDevModeChecks } from 'reselect';
setGlobalDevModeChecks({
  inputStabilityCheck:   'never',
  identityFunctionCheck: 'never',
});

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Legacy NGX modules */
import NGX from './legacy/ngx.js';

// Assign NGX namespace to window scope.
Object.assign(window.NGX, NGX.app);

// Init.
NGX.init();

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* New NGXD React/Redux apps */
import NGXD from './apps/ngxd.js';

// Assign NGXD namespace to window scope.
Object.assign(window.NGXD, NGXD.app);

// Init (inject reference to legacy app so we never have to reference its global namespace).
NGXD.init(window.NGX);
